/**
 * Walkthrough videos on a process (D-062). The limits live here once, for the upload form and for
 * the API that enforces them. docs/BUILD.md §10 "Videos as built".
 */
/** 500 MB: about 20–40 minutes of 1080p screen recording. */
export const MAX_VIDEO_BYTES = 500 * 1024 * 1024;
/**
 * Formats every supported browser plays without conversion. QuickTime (.mov) is not among them:
 * iPhone recordings are often HEVC, which Chrome and Edge on Windows will not play, and there is
 * no transcoding step (no ffmpeg on the server).
 */
export const VIDEO_CONTENT_TYPES = ['video/mp4', 'video/webm'];
/** Block size for the browser's direct upload to Blob Storage: 500 MB is 63 blocks. */
export const VIDEO_BLOCK_BYTES = 8 * 1024 * 1024;
export const MAX_VIDEO_TITLE = 200;
/** What a file name's extension says, when the browser gives no usable type. */
export function videoTypeFor(fileName, browserType) {
    const t = browserType.toLowerCase();
    if (VIDEO_CONTENT_TYPES.includes(t))
        return t;
    const ext = fileName.toLowerCase().split('.').pop();
    if (ext === 'mp4' || ext === 'm4v')
        return 'video/mp4';
    if (ext === 'webm')
        return 'video/webm';
    return null;
}
//# sourceMappingURL=video.js.map